jQuery(function($){

  if(typeof $('.slider-program__big').slick !== "undefined") {

    $('.slider-program__small.by-4').slick({
        infinite: true,
        slidesToShow: 1,
        arrows: false,
        focusOnSelect: true,
        swipe: false,
    });

    $('.slider-program__small:not(.by-4)').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0px',
        arrows: true,
        swipeToSlide: true,
        focusOnSelect: true,
        asNavFor: '.slider-program__big',
        responsive: [
          {
            breakpoint: 767,
            settings: {
                autoplay: true,
                autoplaySpeed: 3500,
            }
          }
        ],
    });

    $('.slider-program__big').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: true,
        asNavFor: '.slider-program__small:not(.by-4)',
        autoplaySpeed: 3500,
        responsive: [
          {
            breakpoint: 767,
            settings: {
                autoplay: false,
            }
          }
        ],
    }).on('afterChange', function(slick, currentSlide) {
      let currentSlideIndex = currentSlide.currentSlide;
      let slideIndex = parseInt(currentSlideIndex / 4);

      $('.slider-program__small.by-4').slick('slickGoTo', slideIndex);
    }); 

    $('.slider-program__small.by-4 .slider-program__small-single').on('click', function() {
      let slideIndex = $(this).data('kl-index');
      $('.slider-program__big').slick('slickGoTo', slideIndex)
    });
    
  }

});